import React from "react"
import * as styles from "./modal.module.css"

export default function Modal(props) {
  return (
    <div
      className={styles.modal}
      style={{ height: props.height, width: props.width }}
    >
      {props.children}
      <button onClick={props.toggleModal}>close</button>
    </div>
  )
}
